import PropTypes from 'prop-types'
import cn from '../modules/cn'

function Header({
  children,
  leadingAddon,
  trailingAddon,
  className,
}) {
  return (
    <div className={cn(
      'flex items-start space-x-2 pb-3',
      className,
    )}
    >
      {leadingAddon}
      <div className="flex-grow flex flex-col justify-center">
        {children}
      </div>
      {trailingAddon}
    </div>
  )
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  leadingAddon: PropTypes.node,
  trailingAddon: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

Header.defaultProps = {
  leadingAddon: null,
  trailingAddon: null,
  className: null,
}

export default Header
